/**********************************************************************
// @@@ START COPYRIGHT @@@
//        AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
//        Copyright 2018 - 2019
//        Avi Solar Energy Pvt Ltd.
//        Protected as an unpublished work.
//  The computer program listings, specifications and documentation
//  herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
//  and shall not be reproduced, copied, disclosed, or used in whole or in part for
//  any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
const menu = {
  items: [
    {
      icon: 'home',
      text: 'Home',
      component: 'home'
    },
    {
      icon: 'overview',
      text: 'Plant Overview',
      component: 'plantOverview'
    },
    {
      icon: 'sld',
      text: 'SLD',
      component: 'sld'
    },
    {
      icon: 'inverterStatus',
      text: 'Plant-Wide Inverter Status',
      component: 'inverter-status'
    },
    {
      icon: 'devices',
      text: 'Devices',
      component: 'devices'
    },
    {
      icon: 'alert',
      text: 'Alert',
      component: 'alert'
    },
    {
      icon: 'analytics',
      text: 'Services',
      component: 'more'
    },
    // {
    //   icon: 'admin',
    //   text: 'Admin',
    //   component: 'admin',
    //   verify: (role) => role === 'super-admin'
    // },
    { divider: true },
    {
      icon: 'logout',
      text: 'Logout',
      component: 'logout'
    }
  ],
  menuItems: [
    {
      icon: 'overview',
      text: 'Plant Overview',
      component: 'plantOverview'
    },
    {
      icon: 'sld',
      text: 'SLD',
      component: 'sld'
    },
    {
      icon: 'inverterStatus',
      text: 'Plant-Wide Inverter Status',
      component: 'inverter-status'
    },
    {
      icon: 'devices',
      text: 'Devices',
      component: 'devices'
    },
    {
      icon: 'alert',
      text: 'Alert',
      component: 'alert'
    },
    {
      icon: 'analytics',
      text: 'More',
      component: 'more'
    },
    { divider: true },
    {
      icon: 'logout',
      text: 'Logout',
      component: 'logout'
    }
  ],
  main_item: [{
    icon: 'support',
    text: 'Support'
  },
  {
    icon: 'logout',
    text: 'Logout',
    route: '/login'
  }],
  // admin menu items
  menu_admin: [
    {
      icon: 'dashboard',
      'icon-alt': 'keyboard_arrow_down',

      text: 'Manage Customer',
      model: true,
      children: [
        {
          icon: 'power_input',
          text: 'Customer',
          route: '/admin/customer'
        },
        {
          icon: 'cloud',
          text: 'Plant',
          route: '/admin/plant'
        },
        {
          icon: 'memory',
          text: 'Users',
          route: '/admin/user'
        }
      ]
    },
    {
      icon: 'device_hub',
      'icon-alt': 'keyboard_arrow_down',
      text: 'Devices',
      model: false,
      children: [
        {
          text: 'Inverter',
          route: '/admin/inverter'
        },
        {
          text: 'WS',
          route: '/admin/ws'
        },
        {
          text: 'SCB',
          route: '/admin/scb'
        },
        {
          text: 'Tracker',
          route: '/admin/tracker'
        },
        {
          text: 'Energy Meter',
          route: '/admin/em'
        },
        {
          text: 'Transformer',
          route: '/admin/transformer'
        },
        {
          text: 'VCB',
          route: '/admin/vcb'
        },
        // { text: 'Fire Alarm', route: '/admin/firealarm' },
        {
          text: 'UPS',
          route: '/admin/ups'
        }
      ]
    },
    {
      icon: 'map',
      'icon-alt': 'keyboard_arrow_down',
      text: 'Layout Config',
      model: false,
      children: [
        {
          text: 'MAP View',
          route: '/map_config'
        },
        {
          text: 'SCB Layout',
          route: '/scb_config'
        }
      ]
    },
    {
      icon: 'settings',
      'icon-alt': 'keyboard_arrow_down',
      text: 'Component Settings',
      model: false,
      children: [{
        text: 'Component Management',
        route: '/admin/component'
      },
      {
        text: 'Plant Components',
        route: '/admin/plant-component'
      }
      ]
    },
    {
      icon: 'history',
      text: 'User Menu',
      route: '/home'
    },
    {
      icon: 'history',
      text: 'Logout',
      route: '/login'
    }
  ],
  mobileItems: [
    {
      icon: 'home',
      text: 'Home',
      component: 'home'
    },
    {
      icon: 'overview',
      text: 'Plant Overview',
      component: 'plantOverview'
    },
    {
      icon: 'devices',
      text: 'Devices',
      component: 'devices'
    },
    {
      icon: 'alert',
      text: 'Alert',
      component: 'alert'
    },
    {
      icon: 'logout',
      text: 'Logout',
      component: 'login'
    }
  ]
}

export default menu
